import { flightstatsNextAppHost } from './host-utils';

export const getFSHost = () => flightstatsNextAppHost();
